// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.stepAiType__u2SYc {
  display: flex;
  flex-direction: column;
  row-gap: 10px;
}

.typeItem__uEQUI {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border: 1px solid var(--tables-primary-row-stroke);
  background: var(--tables-secondary-row-sub-title-surface);
  border-radius: 2px;
  cursor: pointer;
}
.typeItem__uEQUI svg {
  width: 95px;
  height: 54px;
}

.typeItemSelected__qyyIa {
  border: 1px solid var(--inputs-focus-stroke);
}
.typeItemSelected__qyyIa .typeItemTitle__JkPrx {
  font-weight: 700;
}

.typeItemTitle__JkPrx {
  color: var(--legend-for-header-text);
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  text-transform: uppercase;
}

.typeItemDescr__fp0EH {
  margin-top: 10px;
  max-width: 395px;
  color: var(--tables-secondary-row-sub-title-text);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
}

.disabled__LP26_ {
  pointer-events: none;
  opacity: 0.7;
}

.helperText__yVywO {
  color: var(--inputs-error-text-helper);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px;
  letter-spacing: 0.11px;
  margin-top: 4px;
  min-height: 11px;
}
@media (max-width: 850px) {
  .helperText__yVywO {
    font-size: 8px;
    line-height: 8px;
    margin-top: 2px;
    min-height: 8px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/components/modals/AddActionItemModal/components/StepAIType/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,aAAA;EACA,sBAAA;EACA,aAAA;AAzEF;;AA4EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;EACA,kDAAA;EACA,yDAAA;EACA,kBAAA;EACA,eAAA;AAzEF;AA2EE;EACE,WAAA;EACA,YAAA;AAzEJ;;AA6EA;EACE,4CAAA;AA1EF;AA4EE;EACE,gBAAA;AA1EJ;;AA8EA;EACE,oCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;AA3EF;;AA8EA;EACE,gBAAA;EACA,gBAAA;EACA,iDAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AA3EF;;AA8EA;EACE,oBAAA;EACA,YAAA;AA3EF;;AA8EA;EACE,sCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;AA3EF;AA6EE;EAVF;IAWI,cAAA;IACA,gBAAA;IACA,eAAA;IACA,eAAA;EA1EF;AACF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.stepAiType {\n  display: flex;\n  flex-direction: column;\n  row-gap: 10px;\n}\n\n.typeItem {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 20px;\n  border: 1px solid var(--tables-primary-row-stroke);\n  background: var(--tables-secondary-row-sub-title-surface);\n  border-radius: 2px;\n  cursor: pointer;\n\n  svg {\n    width: 95px;\n    height: 54px;\n  }\n}\n\n.typeItemSelected {\n  border: 1px solid var(--inputs-focus-stroke);\n\n  .typeItemTitle {\n    font-weight: 700;\n  }\n}\n\n.typeItemTitle {\n  color: var(--legend-for-header-text);\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 14px;\n  text-transform: uppercase;\n}\n\n.typeItemDescr {\n  margin-top: 10px;\n  max-width: 395px;\n  color: var(--tables-secondary-row-sub-title-text);\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 16px;\n}\n\n.disabled {\n  pointer-events: none;\n  opacity: 0.7;\n}\n\n.helperText {\n  color: var(--inputs-error-text-helper);\n  font-size: 11px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 12px;\n  letter-spacing: 0.11px;\n  margin-top: 4px;\n  min-height: 11px;\n\n  @media (max-width: 850px) {\n    font-size: 8px;\n    line-height: 8px;\n    margin-top: 2px;\n    min-height: 8px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"stepAiType": `stepAiType__u2SYc`,
	"typeItem": `typeItem__uEQUI`,
	"typeItemSelected": `typeItemSelected__qyyIa`,
	"typeItemTitle": `typeItemTitle__JkPrx`,
	"typeItemDescr": `typeItemDescr__fp0EH`,
	"disabled": `disabled__LP26_`,
	"helperText": `helperText__yVywO`
};
module.exports = ___CSS_LOADER_EXPORT___;
